<!-- 采购收货历史 -->
<template>
<div class='page_content'>
    <processAuditAction ref="processAuditAction"></processAuditAction>
    <subComponents ref="showSelectData"></subComponents>
    <div class="page_content_top">
        <div class="page_content_top_line">
            <el-button type="primary" size="mini" @click="actionSet(buttonValue)" v-for="(buttonValue,buttonKey) in buttonList" :key="buttonKey">
                {{buttonValue.jurName}}
            </el-button>

            <el-button type="primary" icon="el-icon-refresh" size="mini" @click="getDataList()">
                刷新
            </el-button>
        </div>
        <div class="page_content_top_line">
            <el-form :inline="true" :model="getRequestData" class="demo-form-inline" v-if="pageShowData[0]">
                <template v-for="(formOneValue,formOneKey) in pageShowData[0].jurconfigform">
                    <el-form-item :label="formOneValue.showField" v-if="formOneValue.isShow==1" :key="formOneKey">
                        <el-input v-if="formOneValue.entityField == 'smId'" clearable v-model="getRequestData.smName" @keyup.enter.native="openSeComponents(formOneValue.searchId,  'smId', 'smName')">
							<el-button @click="openSeComponents(formOneValue.searchId, 'smId', 'smName')" slot="append" icon="el-icon-search"></el-button>
						</el-input>
                        <!-- <el-input v-else-if="formOneValue.entityField == 'opmId'" clearable v-model.trim="getRequestData.opmName" @focus="openSeComponents(formOneValue.searchId,formOneValue.entityField)" size="mini" :maxlength="$store.state.inputLength">
                        </el-input> -->
                       <el-date-picker v-else-if="formOneValue.entityField == 'start'" size="mini" v-model="getRequestData[formOneValue.entityField]" format="yyyy 年 MM 月 dd 日" value-format="timestamp" type="date" placeholder="选择日期">
                        </el-date-picker>
                        <el-date-picker v-else-if="formOneValue.entityField == 'end'" @change="changeTime" size="mini" v-model="getRequestData[formOneValue.entityField]" format="yyyy 年 MM 月 dd 日" value-format="timestamp" type="date" placeholder="选择日期">
                        </el-date-picker>
                        <el-input v-else v-model.trim="getRequestData[formOneValue.entityField]" size="mini" :maxlength="$store.state.inputLength"></el-input>
                    </el-form-item>
                </template>

                <el-form-item>
                    <el-button type="primary" size="mini" @click="searchData">查询</el-button>
                </el-form-item>

            </el-form>
        </div>
    </div>
    <div class="page_content_center">
        <el-table v-if="pageShowData[1]" stripe :data="returnData.list" height="100%" border style="width: 100%" highlight-current-row size="mini">
            <el-table-column label="选择操作" width="80">
                <template slot-scope="scope">
                    <el-radio v-model="selectedDataIndex" :label="scope.$index" border size="mini">
                        <i class="el-icon-thumb"></i>
                    </el-radio>
                </template>
            </el-table-column>
            <el-table-column type="expand" label="详情" width="50">
                <template slot-scope="props">
                    <!-- 辅助信息 -->
                    <el-tabs type="border-card">
                        <el-tab-pane v-if="pageShowData[2]" :label="pageShowData[2].jciName">
                            <el-table :data="[props.row.pisRegoAuxinf]" border style="width: 100%" size="mini">
                                <template v-for="(tableValye,tableKey) in pageShowData[2].jurconfigtable">
                                    <el-table-column v-if="tableValye.isShow==1" :key="tableKey" 
                                    show-overflow-tooltip :min-width="tableValye.fieldWeight"
                                    :prop="tableValye.entityField" :label="tableValye.showField">
                                        <template slot-scope="scope">
                                            <span v-if="tableValye.fieldType == 'date'">
                                                <span v-if="scope.row[tableValye.entityField]">
                                                    {{$common.getLocalTime(scope.row[tableValye.entityField])}}
                                                </span>
                                            </span>
                                            <div v-else>
                                                {{scope.row[tableValye.entityField]}}
                                            </div>
                                        </template>
                                    </el-table-column>
                                </template>

                            </el-table>
                        </el-tab-pane>
                        <!-- 运输信息 -->
                        <el-tab-pane v-if="pageShowData[3]" :label="pageShowData[3].jciName">
                            <el-table :data="[props.row.pisRegoCtri]" border style="width: 100%" size="mini">
                                <template v-for="(tableValye,tableKey) in pageShowData[3].jurconfigtable">
                                    <el-table-column v-if="tableValye.isShow==1" :key="tableKey" 
                                    show-overflow-tooltip :min-width="tableValye.fieldWeight"
                                    :prop="tableValye.entityField" :label="tableValye.showField">
                                        <template slot-scope="scope">
                                            <span v-if="tableValye.fieldType == 'date'">
                                                <span v-if="scope.row[tableValye.entityField]">
                                                    {{$common.getLocalTime(scope.row[tableValye.entityField])}}
                                                </span>
                                            </span>
                                            <span v-else-if="tableValye.isRift == 1">
                                                <a @click="toDetail(scope.row[tableValye.riftField])">{{scope.row[tableValye.entityField]}}</a>
                                            </span>
                                            <span v-else>
                                                {{scope.row[tableValye.entityField]}}
                                            </span>
                                        </template>
                                    </el-table-column>
                                </template>

                            </el-table>
                        </el-tab-pane>
                        <!-- 明细信息 -->
                        <el-tab-pane v-if="pageShowData[4]" :label="pageShowData[4].jciName">
                            <el-table :data="props.row.pisRegoDetail" border style="width: 100%" size="mini">
                                <template v-for="(tableValye,tableKey) in pageShowData[4].jurconfigtable">
                                    <el-table-column v-if="tableValye.isShow==1" :key="tableKey" 
                                    show-overflow-tooltip :min-width="tableValye.fieldWeight"
                                    :prop="tableValye.entityField" :label="tableValye.showField">
                                        <template slot-scope="scope">
                                            <el-tag size="mini" v-if="tableValye.entityField == 'bgiIsdcheck'">
                                                {{scope.row[tableValye.entityField]==0 ? '否' :'是'}}
                                            </el-tag>
                                            <span v-else-if="tableValye.isRift == 1">
                                                <a @click="toDetail(scope.row[tableValye.riftField])">{{scope.row[tableValye.entityField]}}</a>
                                            </span>
                                            <span v-else>
                                                {{scope.row[tableValye.entityField]}}
                                            </span>
                                        </template>
                                    </el-table-column>
                                </template>
                            </el-table>
                        </el-tab-pane>
                    </el-tabs>
                </template>
            </el-table-column>
            <template v-for="(tableValye,tableKey) in pageShowData[1].jurconfigtable">
                <el-table-column v-if="tableValye.isShow==1" :key="tableKey" 
                show-overflow-tooltip :min-width="tableValye.fieldWeight"
                :prop="tableValye.entityField" :label="tableValye.showField">
                    <template slot="header">
                        <div>
                            <el-tooltip :content="tableValye.showField" placement="top">
                                <div class="long_title"><span>{{tableValye.showField}}</span></div>
                            </el-tooltip>
                        </div>
                    </template>
                    <template slot-scope="scope">
                        <span v-if="tableValye.fieldType == 'date'">
                            {{$common.getLocalTime(scope.row[tableValye.entityField])}}
                        </span>
                        <span v-else-if="tableValye.isRift == 1">
                            <a @click="toDetail(scope.row[tableValye.riftField])">{{scope.row[tableValye.entityField]}}</a>
                        </span>
                        <el-tag size="mini" v-else-if="tableValye.entityField == 'psrgmState'">{{$common.getIsGsp(tableValye.formatterContent,scope.row.psrgmState)}}</el-tag>
                        <span v-else>
                            {{scope.row[tableValye.entityField]}}
                        </span>
                    </template>
                </el-table-column>
            </template>

        </el-table>
    </div>
    <div class="page_content_bottom">
        <el-pagination background @size-change="setDataPageSize" @current-change="setDataPageNumber" :current-page="getRequestData.page" :page-sizes="[30,50,100,500]" :page-size="30" layout="total, sizes, prev, pager, next, jumper" :total="returnData.total">
        </el-pagination>
    </div>
    <el-dialog :title="seTitle" v-if="DialogVisible" :visible.sync="DialogVisible" :width="seWidth">
        <SearchScheme ref="searchScheme" :id="seId" :parentSearchData="parentSearchData" @TranData="getSeData" @getWidth="getSeWidth" @sendTitle="getSearchName" />
    </el-dialog>
</div>
</template>

<script>
//这里可以导入其他文件（比如：组件，工具js，第三方插件js，json文件，图片文件等等）
//例如：import 《组件名称》 from '《组件路径》';
import SearchScheme from "../../../byComponents/SearchScheme.vue";
export default {
    //import引入的组件需要注入到对象中才能使用
    components: {
        SearchScheme
    },
    data() {
        //这里存放数据
        return {
            seTitle: "",
            DialogVisible: false,
            seWidth: "",
            seId: "",
            fil: "",
            getRequestData: {
                psrgmPurchaser: "",
                psrgmBuycus: "", // 购进单位
                psrgmBuycusName: "", // 购进单位名称
                smId: "",
                smName: "",
                opmId: "",
                opmName: "",
                page: 1,
                rows: 30,
                start: new Date(new Date().toLocaleDateString()).getTime() - 31 * 24 * 3600 * 1000,
                end: new Date(new Date().toLocaleDateString()).getTime() + 24 * 60 * 60 * 1000 - 1,
            },
            returnData: {
                pages: 0, // 总页数
                total: 0, // 总条数
                pageNum: 0, // 当前页数
                list: [],
            },
            buttonList: [],

            pageShowData: [],
            selectedDataIndex: 0,
            parentSearchData: {}
        };
    },
    //监听属性 类似于data概念
    computed: {},
    //监控data中的数据变化
    watch: {
        "getRequestData.psrgmBuycusName": {
            handler: function (newValue, oldValue) {
                if (newValue == "") {
                    this.getRequestData.psrgmBuycus = "";
                }
            },
            deep: true,
        },
    },
    //方法集合
    methods: {
        changeTime(val) {
            if (val) {
                var time = val + 24 * 60 * 60 * 1000 - 1;
                this.getRequestData.end = time;
            }
        },
         // 子组件触发
        drawerCancel() {
            this.showStatus = false
            this.getDataList()
        },
        // 点击穿透字段 传参单号
        toDetail(orderId) {
           if (orderId) {
               // 设置为true 打开穿透组件首页    
                var isPenetrate = true
                // 设置缓存 存入点击单号
                this.resetSetItem('penetrateOrderId', orderId);
                // 与父级跨域通信 传递isPenetrate参数
                window.parent.postMessage({  //向窗口发送MessageEvent消息
                    cmd: 'returnFormJson',
                    params: {isPenetrate} //参数
                }, '*');
           }
        },
        openSeComponents(e, fil, field) {
            console.log(e);
            this.seId = e;
            this.fil = fil;
            this.DialogVisible = true;
            this.parentSearchData[field] = this.getRequestData[field]
        },
        getSeData(val) {
            console.log(val);
            if (this.fil == "smId") {
                this.getRequestData.smName = val.smName;
                this.getRequestData.smId = val.smId;
            } else if (this.fil == "opmId") {
                this.getRequestData.opmId = val.opmId;
                this.getRequestData.opmName = val.opmName;
            }
            this.DialogVisible = false;
        },
        getSeWidth(e) {
            this.seWidth = e + "%";
        },
        getSearchName(e) {
            this.seTitle = e;
        },
        isShowData(name, value) {
            console.log(name);
            switch (name) {
                case "psrgmBuycus":
                    var dataInfo = sessionStorage.getItem("selectSupplierData");
                    if (dataInfo) {
                        dataInfo = JSON.parse(dataInfo);
                        this.getRequestData.psrgmBuycus = dataInfo.smId;
                        this.getRequestData.psrgmBuycusName = dataInfo.smName;
                    }
                    break;
                default:
                    this.sendDataInfo[name] = value;
            }
        },

        // 获取数据列表
        async getPageInfo() {
            var pathId = parent.getMenuInfo(this.$route.path);
            let responseData = await this.$http.pageFormText({
                ids: [pathId.jurId]
            });
            if (responseData.status == 200) {
                this.pageShowData = responseData.result;

                console.log(responseData.result);
            } else {
                this.$message({
                    message: responseData.message,
                    type: "error",
                });
            }
        },

        // 动作集合
        actionSet(actionData) {
            var dataInfo = this.returnData.list[this.selectedDataIndex];
            if (!dataInfo) {
                this.$message({
                    message: "请先选中要操作的数据",
                    type: "error",
                });
                return false;
            }
            switch (actionData.actionType) {
                case 0:
                    this.$refs["processAuditAction"].openBox(0, dataInfo.psomId);
                    break;
                case 1:
                    this.$refs["processAuditAction"].openBox(1, dataInfo.psomId);
                    break;
            }
        },
        // 数据搜索
        searchData() {
            this.getRequestData.page = 1;
            this.getDataList();
        },
        // 数据翻页
        setDataPageNumber(val) {
            this.getRequestData.page = val;
            this.getDataList();
        },

        // 切换显示条数
        setDataPageSize(val) {
            this.getRequestData.page = 1;
            this.getRequestData.rows = val;
            this.getDataList();
        },

        // 获取数据列表
        async getDataList() {
            if (this.getRequestData.smName == "") {
                this.getRequestData.smId = "";
            }
            if (this.getRequestData.opmName == "") {
                this.getRequestData.opmId = "";
            }
            let responseData = await this.$http.getPurchaseReceivingHistory(
                this.getRequestData
            );
            if (responseData.status == 200) {
                this.returnData.list = responseData.result.list;
                this.returnData.pages = responseData.result.pages;
                this.returnData.total = responseData.result.total;
                this.returnData.pageNum = responseData.result.pageNum;
                this.selectedDataIndex = 0;
            } else {
                this.$message({
                    message: responseData.message,
                    type: "error",
                });
            }
        },

        async getButtonList() {
            this.buttonList = await this.$common.getActionButton();
        },
        //获取状态
        getIsGsp(str, val) {
            try {
                str && str.replace(/\\/g, '')
                let arr = JSON.parse(str)
                let len = arr.length
                let newStr = ''
                for (let i = 0; i < len; i++) {
                    if (arr[i].key === val) {
                        newStr = arr[i].value
                        break;
                    }
                }
                return newStr
            } catch (ex) {
                return str
            }
        },


    },
    //生命周期 - 创建完成（可以访问当前this实例）
    created() {
        this.getPageInfo();
        this.getDataList();
        this.getButtonList();
    },
    //生命周期 - 挂载完成（可以访问DOM元素）
    mounted() {},
    beforeCreate() {}, //生命周期 - 创建之前
    beforeMount() {}, //生命周期 - 挂载之前
    beforeUpdate() {}, //生命周期 - 更新之前
    updated() {}, //生命周期 - 更新之后
    beforeDestroy() {}, //生命周期 - 销毁之前
    destroyed() {}, //生命周期 - 销毁完成
    activated() {}, //如果页面有keep-alive缓存功能，这个函数会触发
};
</script>

<style scoped>
.table_content_tag {
    margin-right: 1rem;
}

.el-tabs--border-card_new {
    height: 85vh;
    overflow-y: scroll;
}
</style>
